/**
 * @fileoverview Index file for all composite agents.
 * Each composite agent orchestrates multiple primitive agents to perform complex operations.
 */

// Entities > Characters > Analysis
export { definition as characterSnapshotterV2 } from './character-snapshotter-v2';

// Meta > Style
export { definition as extractStyleguideV2 } from './extract-styleguide-v2';

// Writing > Content
export { definition as chapterDrafterEnhancedV2 } from './chapter-drafter-enhanced-v2';
export { definition as chapterDrafterComparisonV2 } from './chapter-drafter-comparison-v2';
export { definition as draftAllChapters } from './draft-all-chapters';

// Writing > Refinement Comparison
export { definition as draftRefinerComparisonV2 } from './draft-refiner-comparison-v2';
export { definition as proseExpanderComparisonV2 } from './prose-expander-comparison-v2';
export { definition as proseShortenerComparisonV2 } from './prose-shortener-comparison-v2';

// Writing > Review
export { definition as critiqueCommitteeV2 } from './critique-committee-v2';
export { definition as continuityCommitteeV2 } from './continuity-committee-v2';

// Writing > Judgment Committee
export { definition as proseComparerCommitteeV2 } from './prose-comparer-committee-v2';

// Writing > Iterative Refinement
export { definition as iterativeRefinementV2 } from './iterative-refinement-v2';

// Writing > Refine Session
export { definition as runRefineV2 } from './run-refine-v2';
export { definition as runRefineFullV2 } from './run-refine-full-v2';

// Visuals > Images
export { definition as quickImageV2 } from './quick-image-v2';

// World Building > Extraction
export { definition as extractWorldElementsV3 } from './extract-world-elements-v3';

// Visuals > World Element Portraits
export { definition as generateWorldElementPortraitV2 } from './generate-world-element-portrait-v2';

// Narrative > Chapters > Planning
export { definition as chapterPlannerCompositeV1 } from './chapter-planner-composite-v1';

// Narrative > Story Updating
export { definition as structuralRefreshCompositeV1 } from './structural-refresh-composite-v1';

// Import > Story > Storyline Pipeline
export { definition as storylineExtractionPipelineV1 } from './storyline-extraction-pipeline-v1';

// Import > Story > Synopsis Pipeline
export { definition as synopsisExtractionPipelineV3 } from './synopsis-extraction-pipeline-v3';


// Collect all composite definitions for easy import
import { definition as characterSnapshotterV2Def } from './character-snapshotter-v2';
import { definition as extractStyleguideV2Def } from './extract-styleguide-v2';
import { definition as chapterDrafterEnhancedV2Def } from './chapter-drafter-enhanced-v2';
import { definition as chapterDrafterComparisonV2Def } from './chapter-drafter-comparison-v2';
import { definition as draftAllChaptersDef } from './draft-all-chapters';
import { definition as draftRefinerComparisonV2Def } from './draft-refiner-comparison-v2';
import { definition as proseExpanderComparisonV2Def } from './prose-expander-comparison-v2';
import { definition as proseShortenerComparisonV2Def } from './prose-shortener-comparison-v2';
import { definition as critiqueCommitteeV2Def } from './critique-committee-v2';
import { definition as continuityCommitteeV2Def } from './continuity-committee-v2';
import { definition as proseComparerCommitteeV2Def } from './prose-comparer-committee-v2';
import { definition as iterativeRefinementV2Def } from './iterative-refinement-v2';
import { definition as runRefineV2Def } from './run-refine-v2';
import { definition as runRefineFullV2Def } from './run-refine-full-v2';
import { definition as quickImageV2Def } from './quick-image-v2';
// World Building > Extraction
import { definition as extractWorldElementsV3Def } from './extract-world-elements-v3';
// Visuals > World Element Portraits
import { definition as generateWorldElementPortraitV2Def } from './generate-world-element-portrait-v2';
// Narrative > Chapters > Planning
import { definition as chapterPlannerCompositeV1Def } from './chapter-planner-composite-v1';
// Narrative > Story Updating
import { definition as structuralRefreshCompositeV1Def } from './structural-refresh-composite-v1';
// Import > Story > Storyline Pipeline
import { definition as storylineExtractionPipelineV1Def } from './storyline-extraction-pipeline-v1';
// Import > Story > Synopsis Pipeline
import { definition as synopsisExtractionPipelineV3Def } from './synopsis-extraction-pipeline-v3';

export const COMPOSITE_AGENT_DEFINITIONS = [
  characterSnapshotterV2Def,
  extractStyleguideV2Def,
  chapterDrafterEnhancedV2Def,
  chapterDrafterComparisonV2Def,
  draftAllChaptersDef,
  draftRefinerComparisonV2Def,
  proseExpanderComparisonV2Def,
  proseShortenerComparisonV2Def,
  critiqueCommitteeV2Def,
  continuityCommitteeV2Def,
  proseComparerCommitteeV2Def,
  iterativeRefinementV2Def,
  runRefineV2Def,
  runRefineFullV2Def,
  quickImageV2Def,
  // World Building > Extraction
  extractWorldElementsV3Def,
  // Visuals > World Element Portraits
  generateWorldElementPortraitV2Def,
  // Narrative > Chapters > Planning
  chapterPlannerCompositeV1Def,
  // Narrative > Story Updating
  structuralRefreshCompositeV1Def,
  // Import > Story > Storyline Pipeline
  storylineExtractionPipelineV1Def,
  // Import > Story > Synopsis Pipeline
  synopsisExtractionPipelineV3Def,
];
